import api from "./api";

export function getAboutPage(country_id) {
    return api.get(`/homepage/${country_id}`);
}